export const ClinicTaxTypes = {
    Cpf: "CPF",
    Cnpj: "CNPJ",
} as const;

export type ClinicTaxType = (typeof ClinicTaxTypes)[keyof typeof ClinicTaxTypes];

export const ClinicRoles = {
    Manager: "ClinicManager",
    Therapist: "Therapist",
    Secretary: "Secretary",
    Finance: "Finance",
} as const;

export type ClinicRole = (typeof ClinicRoles)[keyof typeof ClinicRoles];

export function hasClinicFinanceRole(user: { clinicRoles?: readonly string[] | null } | null | undefined): boolean {
    return user?.clinicRoles?.includes(ClinicRoles.Finance) ?? false;
}

import { getTranslation } from "@mivo/i18n";
import { CLINIC_ROLE_TRANSLATIONS } from "./clinicSharedConstants";

export function clinicRoleLabel(role: string): string {
    switch (role) {
        case ClinicRoles.Manager:
            return getTranslation(CLINIC_ROLE_TRANSLATIONS.manager);
        case ClinicRoles.Therapist:
            return getTranslation(CLINIC_ROLE_TRANSLATIONS.therapist);
        case ClinicRoles.Secretary:
            return getTranslation(CLINIC_ROLE_TRANSLATIONS.secretary);
        case ClinicRoles.Finance:
            return getTranslation(CLINIC_ROLE_TRANSLATIONS.finance);
        default:
            return role;
    }
}

export const ClinicPlanLimits = {
    includedProfessionalSeats: 3,
    includedSecretarySeats: 1,
    patientsPerProfessional: 100,
    storageBytesPerProfessional: 1_073_741_824,
    extraProfessionalSeatPriceBrl: 19.9,
    extraSecretarySeatPriceBrl: 9.9,
    extraFinanceUserSeatPriceBrl: 14.9,
    provisionalBasePriceBrl: 59.9,
} as const;
